"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var mithril_1 = require("../../mithril");
var theme_1 = require("../theme");
var CSS = {
    sidebar: 'c-Sidebar'
};
var styles = (_a = {},
    _a[CSS.sidebar] = {
        width: '20%',
        'min-width': '350px',
        display: 'flex',
        'flex-direction': 'column'
    },
    _a);
(0, theme_1.addStyles)(styles);
var Sidebar = /** @class */ (function () {
    function Sidebar() {
    }
    Sidebar.prototype.view = function (children) {
        return (0, mithril_1.m)('div', {
            className: CSS.sidebar
        }, children);
    };
    return Sidebar;
}());
exports.Sidebar = Sidebar;
//# sourceMappingURL=sidebar.component.js.map